"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Sidebar/icons.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _types = require('./types');

// The desktop sidebar's icons. Each section keeps the rail's own icon
// (assets/icons/sidebar/<name>-grey.svg, the mobile tab bar's too), drawn as a
// mask in `currentColor` so the colour comes from the token on the parent
// (.blm-nav--glyph in sidebar/_desktop.scss). The collapse toggle is new to
// the sidebar, so it is a stroke icon like the inbox list's
// (InboxList/icons.tsx): 24px grid, 1.75 stroke.





const makeIcon = (paths) => {
  const StrokeIcon = ({ size = 20 }) => (
    _react2.default.createElement('svg', {
      width: size,
      height: size,
      viewBox: "0 0 24 24"   ,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      'aria-hidden': "true",
      focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}

      ,  paths 
    )
  )
  return StrokeIcon
}

 const ToggleIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "3", y: "4.5", width: "18", height: "15", rx: "2.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )
  , _react2.default.createElement('path', { d: "M9.5 4.5v15" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )
)); exports.ToggleIcon = ToggleIcon

const makeRailIcon = (name) => {
  const RailIcon = () => (
    _react2.default.createElement('span', { className: `blm-nav--glyph blm-nav--glyph-${name}`, 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
  )
  return RailIcon
}

// Forms is new to the rail, so it has no rail asset: a stroke icon like the
// toggle, at the rail glyphs' size.
 const FormsIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "5", y: "3", width: "14", height: "18", rx: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
  , _react2.default.createElement('path', { d: "M9 8h6M9 12h6M9 16h4"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
)); exports.FormsIcon = FormsIcon

 const ROUTE_ICONS = Object.fromEntries(
  Object.values(_types.RouteName).map(name => [name, name === _types.RouteName.forms ? exports.FormsIcon : makeRailIcon(name)]),
) ; exports.ROUTE_ICONS = ROUTE_ICONS
